import { APIFeatures } from '../../core/util/apifeatures';
import { BaseContext } from '../../utils/basecontext';
import { SixdeeCRBTAPIProcessorFactory } from '../../core/apiprocessorfactory';


export interface APIModel
{
    
}

export interface APIModelHandler
{
    onSuccess(feature: APIFeatures, description: string, data: any): void;
    onFailure(feature: APIFeatures, description: string, data: any): void;
}

export class APIModelImpl implements APIModel
{
    constructor(private applicationContext: BaseContext, private apiModelHandler: APIModelHandler)
    {

    }

    getAPIProcesssorFactory(): SixdeeCRBTAPIProcessorFactory
    {
        return this.getContext().getAPIProcessorFactory();
    }

    getContext(): BaseContext
    {
        return this.applicationContext;
    }

    getAPIModelHandler(): APIModelHandler
    {
        return this.apiModelHandler;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/uicomponentapimodel.tsx